<button
  class="reportPicker"
  mat-button
  [matMenuTriggerFor]="reportPickerMenu"
  [disabled]="disabled()"
  (click)="onMenuTriggered()"
>
  <div class="d-flex w-100 align-items-center text-truncate">
    @let sr = reports() | findByProperty: 'id' : selectedReportId();
    <span class="text-truncate" [title]="sr?.customName">
      {{ sr?.customName }}
    </span>
    <mat-icon class="iconRight ms-auto" svgIcon="menu-down" />
  </div>
</button>

<mat-menu #reportPickerMenu="matMenu" class="mt-2 navbarMenuPanel">
  @for (report of reports() | sort: 'customName' : 'asc'; track report.id) {
    <button
      mat-menu-item
      class="reportPicker_item"
      [ngClass]="{ 'selectedReport': report.id === selectedReportId() }"
      (click)="report.id !== selectedReportId() && onReportChange(report)"
    >
      <div class="d-flex w-100 align-items-center text-truncate">
        <span class="text-truncate" [title]="report.customName">
          {{ report.customName }}
        </span>
      </div>
    </button>
  }
</mat-menu>
